import styled, { CSSProperties } from 'styled-components';
import { FlexTypes } from './style.types';

const Flex = styled.div<FlexTypes & CSSProperties>`
  display: flex;
  width: ${({ width }) => width || 'auto'};
  gap: ${({ gap }) => gap || '1.5rem'};
  flex-wrap: ${({ flexWrap }) => flexWrap || 'wrap'};
  margin: ${({ margin }) => margin};
`;

const ContentAlign = styled.div<
  { justifyContent?: string; alignItems?: string; gap?: string } & CSSProperties
>`
  display: flex;
  justify-content: ${({ justifyContent }) => justifyContent || 'start'};
  align-items: ${({ alignItems }) => alignItems || 'start'};
  gap: ${({ gap }) => gap || '1.5rem'};
  margin: ${({ margin }) => margin};
  width: 100%;
`;
const CenterAlign = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

const TextEllipsis = styled.div<CSSProperties>`
  width: ${({ width }) => width || 'auto'};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-wrap: break-word;
`;
export { Flex, ContentAlign, CenterAlign, TextEllipsis };
